module.exports = __webpack_public_path__ + "static/media/bn_synthesis1.99d9c663.png";